import { Helmet } from 'react-helmet-async'
import RenderIf from './components/ui/render-if'
import {
  UserServiceTenantGqlOutput,
  useUserServiceTenantByDomainQuery,
} from './generated/graphql'
import { graphqlClient } from './libs/graphql-client'

const HelmetHeader = () => {
  // Fetch organizations for organization selector
  const { data, isFetching, isError, isLoading } =
    useUserServiceTenantByDomainQuery(
      graphqlClient,
      { domain: window.location.hostname },
      { staleTime: Infinity, refetchOnWindowFocus: false }
    )

  const {
    banner = '',
    title = '',
    favicon = '/images/favicon.png',
    domain = '',
    description = '',
  } = (data?.userServiceTenantByDomain || {}) as UserServiceTenantGqlOutput

  return (
    <RenderIf
      condition={isFetching || isError || !data || isLoading}
      fallback={<></>}
    >
      <Helmet>
        {/* Standard metadata tags */}
        <link rel='icon' type='image/svg+xml' href={favicon || ''} />
        <link rel='icon' type='image/png' href={favicon || ''} />

        <title>{title}</title>
        <meta name='title' content={title || 'Portal'} />

        {/* Canonical link */}
        <link rel='canonical' href={domain || window.location.href} />
        <meta name='description' content={description || ''} />
        {/* Open Graph tags (OG) */}
        <meta property='og:url' content={domain || window.location.href} />
        <meta property='og:type' content='website' />
        <meta property='og:title' content={title || ''} />
        <meta property='og:description' content={description || ''} />
        {/* OG image tags */}
        <meta property='og:image' content={banner || ''} />
        <meta property='og:image:secure_url' content={banner || ''} />
        <meta property='og:image:type' content='image/jpeg' />
        <meta property='og:image:width' content='200' />
        <meta property='og:image:alt' content={`Image of ${title} site`} />
        {/* Twitter tags */}
        <meta name='twitter:creator' content={title || ''} />
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:title' content={title || ''} />
        <meta name='twitter:description' content={description || ''} />
      </Helmet>
    </RenderIf>
  )
}

export default HelmetHeader
